import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/down.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-3aa7fae4")

_pushScopeId("data-v-3aa7fae4")
const _hoisted_1 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_5 = {
  key: 0,
  class: "editRecipient"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_11 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_15 = { class: "corePerformance" }
const _hoisted_16 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("内存风险")
], -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("内存趋势")
], -1)
const _hoisted_19 = { class: "labelStyle" }
const _hoisted_20 = { style: {"color":"gray"} }
const _hoisted_21 = { class: "corePerformance" }
const _hoisted_22 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("内存模块信息")
], -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("内存对象详情")
], -1)
const _hoisted_25 = { style: {"margin-bottom":"8px"} }
const _hoisted_26 = { style: {"color":"gray"} }
const _hoisted_27 = { class: "corePerformance10" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = {
  class: "spacName",
  style: {"display":"flex","justify-content":"flex-end"}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_h8 = _resolveComponent("h8")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode(_component_el_form, {
                    class: "spacForm",
                    size: "mini",
                    inline: true
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_form_item, { label: "测试任务" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.taskId,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.taskId = $event)),
                            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.detailChange())),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.RecentTaskrecord, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { label: "对比版本" }, {
                        default: _withId(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.dateVersion,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dateVersion = $event)),
                            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.detailChange())),
                            placeholder: "请选择"
                          }, {
                            default: _withId(() => [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateOptions, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item,
                                  label: item,
                                  value: item
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, null, {
                        default: _withId(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _ctx.sendOut,
                            class: "down_img"
                          }, {
                            default: _withId(() => [
                              _hoisted_3,
                              _hoisted_4
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_5, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "100px",
                          model: _ctx.formMail,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.title,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formMail.title = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.Sender,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formMail.Sender = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _hoisted_6,
                                    _hoisted_7,
                                    _hoisted_8,
                                    _hoisted_9,
                                    _hoisted_10,
                                    _hoisted_11,
                                    _hoisted_12
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.addressee,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formMail.addressee = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.CC_List,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送报告吗？",
                              onConfirm: _cache[9] || (_cache[9] = ($event: any) => (_ctx.save_report(false))),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: _ctx.get_is_super,
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_13
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "info",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.edit = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_14
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createVNode("div", _hoisted_15, [
                    _hoisted_16,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.riskTable, (item, index) => {
                      return (_openBlock(), _createBlock("div", { key: index }, [
                        _createVNode(_component_h8, null, {
                          default: _withId(() => [
                            _hoisted_17,
                            _createTextVNode(" " + _toDisplayString(item.scene), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_table, {
                          data: item.data
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, { label: "测试场景" }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(scope.row?.name), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: '内存变化(' + _ctx.newVersion + 'vs' + _ctx.oldVersion + ')'
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.deviceList, (v, i) => {
                                  return (_openBlock(), _createBlock(_component_el_table_column, {
                                    label: v,
                                    key: i
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", {
                                        style: 
                            'color:' +
                            _ctx.tdr_risk(scope.row.data.new[i], item.deviceLevel[i])
                          
                                      }, _toDisplayString(_ctx.company(scope.row.data.new[i])), 5),
                                      _createVNode("span", {
                                        style: 
                            'color:' +
                            _ctx.com_num_color(
                              scope.row.data.new[i],
                              scope.row.data.old[i]
                            )
                          
                                      }, "(" + _toDisplayString(_ctx.getNum(
                              scope.row.data.new[i],
                              scope.row.data.old[i],
                              "risk"
                            )) + ")", 5)
                                    ]),
                                    _: 2
                                  }, 1032, ["label"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["label"]),
                            _createVNode(_component_el_table_column, { label: "趋势风险" }, {
                              default: _withId((scope) => [
                                _createVNode("span", {
                                  style: 
                          'color:' +
                          _ctx.get_risk_color(
                            _ctx.getRisk(
                              scope.row.data.new,
                              scope.row.data.old,
                              item.deviceList
                            )
                          )
                        
                                }, _toDisplayString(_ctx.getRisk(
                            scope.row.data.new,
                            scope.row.data.old,
                            item.deviceList
                          )), 5)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["data"])
                      ]))
                    }), 128))
                  ], 512), [
                    [_directive_loading, _ctx.loading]
                  ]),
                  _withDirectives(_createVNode("div", null, [
                    _hoisted_18,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.trendList, (item, index) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "FPStrend",
                        style: {"width":"100%","height":"350px"},
                        key: index
                      }, [
                        _createVNode(_component_el_card, null, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_19, _toDisplayString(item.device_name), 1),
                            _createVNode("div", _hoisted_20, "场景：" + _toDisplayString(item.chinese), 1),
                            _createVNode("div", {
                              style: {"width":"100%","height":"350px"},
                              id: 'performance_line' + item.chinese
                            }, null, 8, ["id"])
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 128))
                  ], 512), [
                    [_directive_loading, _ctx.loading]
                  ]),
                  _withDirectives(_createVNode("div", _hoisted_21, [
                    _hoisted_22,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.memoryTable, (item, index) => {
                      return (_openBlock(), _createBlock("div", { key: index }, [
                        _createVNode(_component_h8, null, {
                          default: _withId(() => [
                            _hoisted_23,
                            _createTextVNode(" " + _toDisplayString(item.scene), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_table, {
                          "span-method": _ctx.cellMerge,
                          data: item.data
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, { label: "类别" }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(scope.row?.name), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, { label: "类型" }, {
                              default: _withId((scope) => [
                                _createVNode("span", null, _toDisplayString(scope.row?.label), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: '内存变化(' + _ctx.newVersion + 'vs' + _ctx.oldVersion + ')'
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.deviceList, (v, i) => {
                                  return (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: i,
                                    label: v
                                  }, {
                                    default: _withId((scope) => [
                                      _createVNode("span", null, _toDisplayString(scope.row.data[i].new === null
                            ? "0"
                            : _ctx.company(scope.row.data[i].new)), 1),
                                      _createVNode("span", {
                                        style: 
                            'color:' +
                            _ctx.com_num_color(
                              scope.row.data[i].new,
                              scope.row.data[i].old
                            )
                          
                                      }, "(" + _toDisplayString(_ctx.getNum(
                              scope.row.data[i].new,
                              scope.row.data[i].old,
                              "moudle"
                            )) + ")", 5)
                                    ]),
                                    _: 2
                                  }, 1032, ["label"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["label"])
                          ]),
                          _: 2
                        }, 1032, ["span-method", "data"])
                      ]))
                    }), 128))
                  ], 512), [
                    [_directive_loading, _ctx.loading]
                  ]),
                  _withDirectives(_createVNode("div", null, [
                    _hoisted_24,
                    _createVNode("div", _hoisted_25, [
                      _createVNode("span", _hoisted_26, "场景：" + _toDisplayString(_ctx.memoryTableData?.device_name +
                    "-" +
                    _ctx.memoryTableData?.chinese), 1)
                    ]),
                    _createVNode("div", _hoisted_27, [
                      _createVNode(_component_el_form, {
                        size: "mini",
                        inline: true
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "搜索" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.serch_input,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.serch_input = $event)),
                                onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.serchChange())),
                                "prefix-icon": "el-icon-search",
                                size: "mini"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createVNode(_component_el_form_item, { label: "搜索" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formMail.title,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formMail.title = $event)),
                                "prefix-icon": "el-icon-search",
                                size: "mini"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, false]
                          ])
                        ]),
                        _: 1
                      }),
                      _withDirectives(_createVNode(_component_el_table, {
                        border: "",
                        data: _ctx.deepUnityMemoryList.list,
                        onSortChange: _ctx.sort_change
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.details_list, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_table_column, {
                              key: item.label,
                              "min-width": item.label == '名称' ? '67%' : '16.5%',
                              index: index,
                              label: item.label,
                              align: "left"
                            }, {
                              default: _withId((scope) => [
                                (item.prop != 'size')
                                  ? (_openBlock(), _createBlock("span", {
                                      key: 0,
                                      id: scope.row.id
                                    }, _toDisplayString(scope.row[item.prop]), 9, ["id"]))
                                  : (_openBlock(), _createBlock("span", _hoisted_28, _toDisplayString(_ctx.company(scope.row.size)), 1)),
                                (item.prop == 'size')
                                  ? (_openBlock(), _createBlock("span", {
                                      key: 2,
                                      style: 
                          'color:' +
                          _ctx.deviationColor(scope.row.size - scope.row.old_size)
                        
                                    }, _toDisplayString(scope.row.size - scope.row.old_size == 0 ? "" : "(") + _toDisplayString(scope.row.size - scope.row.old_size > 0 ? "+" : "") + _toDisplayString(scope.row.size - scope.row.old_size == 0
                            ? ""
                            : _ctx.company(scope.row.size - scope.row.old_size)) + _toDisplayString(scope.row.size - scope.row.old_size == 0 ? "" : ")"), 5))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["min-width", "index", "label"]))
                          }), 128)),
                          _createVNode(_component_el_table_column, {
                            "min-width": "16.5%",
                            sortable: "",
                            prop: "size",
                            label: "size"
                          }, {
                            default: _withId((scope) => [
                              _createVNode("span", null, _toDisplayString(_ctx.company(scope.row.size)), 1),
                              _createVNode("span", {
                                style: 
                          'color:' +
                          _ctx.deviationColor(scope.row.size - scope.row.old_size)
                        
                              }, _toDisplayString(scope.row.size - scope.row.old_size == 0 ? "" : "(") + _toDisplayString(scope.row.size - scope.row.old_size > 0 ? "+" : "") + _toDisplayString(scope.row.size - scope.row.old_size == 0
                            ? ""
                            : _ctx.company(scope.row.size - scope.row.old_size)) + _toDisplayString(scope.row.size - scope.row.old_size == 0 ? "" : ")"), 5)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data", "onSortChange"]), [
                        [_directive_loading, _ctx.allTableLoading]
                      ]),
                      _createVNode("div", _hoisted_29, [
                        _createVNode(_component_el_form, {
                          style: {"display":"flex","align-items":"center"},
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "每页"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.size,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.size = $event)),
                                  style: {"width":"55px","height":"28px"},
                                  onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onSearch()))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              style: {"margin-bottom":"0"},
                              label: "条记录"
                            }),
                            _createVNode(_component_el_form_item, { style: {"margin-bottom":"0"} }, {
                              default: _withId(() => [
                                _createVNode(_component_el_pagination, {
                                  style: {"text-align":"right"},
                                  currentPage: _ctx.currentPage,
                                  "onUpdate:currentPage": _cache[16] || (_cache[16] = ($event: any) => (_ctx.currentPage = $event)),
                                  "page-size": _ctx.size,
                                  total: _ctx.deepUnityMemoryList.count,
                                  layout: "total, prev, pager, next,jumper",
                                  onCurrentChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleCurrentChange()))
                                }, null, 8, ["currentPage", "page-size", "total"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ], 512), [
                    [_directive_loading, _ctx.loading]
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})